export * from './packaging.component';
export * from './packaging.routes';
export * from './packaging-item/packaging-item.component';



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/fulfillment.release/src/app/packaging/index.ts